import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {LOCATION_TYPES} from '@/globals';
import {LocationModel, SiteModel} from '@/sdk';
import {SitesApi} from '@/sdk/api-services';
import {LocationApi} from '@/sdk/api-services/location.api';
import SiteSetupLocationFormComponent from '@/views/client/site-setup/site-setup-location-form/site-setup-location-details-form.component';
import SiteSetupSearchComponent from '@/views/client/site-setup/site-setup-search/site-setup-search.component';
import DistributionPanelFormComponent from '@/views/shared/distribution-panel-form/distribution-panel-form.component';
import EquipmentDetailsFormComponent from '@/views/shared/equipment-details-form/equipment-details-form.component';
import JunctionBoxDetailsFormComponent from '@/views/shared/junction-box-details-form/junction-box-details-form.component';
import SaveDocumentationFileDialogComponent from '@/views/shared/save-documentation-file-dialog/save-documentation-file-dialog.component';
import SaveDocumentationFolderDialogComponent from '@/views/shared/save-documentation-folder-dialog/save-documentation-folder-dialog.component';
import SaveLocationDialogComponent from '@/views/shared/save-location-dialog/save-location-dialog.component';
import {SiteLocationService} from '@/views/shared/services/site-location.service';
import SiteDasboardComponent from '@/views/site-dashboard/site-dashboard.component';
import {Component} from 'vue-property-decorator';
import SiteSetupAreaBrowserComponent from '../site-setup-area-browser/site-setup-area-browser.component';

@Component({
    name: 'SiteSetupMainComponent',
    components: {
        SiteSetupAreaBrowserComponent,
        SiteSetupSearchComponent,
        SiteSetupLocationFormComponent,
        SaveLocationDialogComponent,
        SaveDocumentationFolderDialogComponent,
        SaveDocumentationFileDialogComponent,

        EquipmentDetailsFormComponent,
        JunctionBoxDetailsFormComponent,
        DistributionPanelFormComponent,

        SiteDasboardComponent,
    },
})
export default class SiteSetupMainComponent extends VueWrapper {
    public $refs!: {
        areaBrowserElem: HTMLDivElement;
        searchSectionElem: HTMLDivElement;
        searchSectionParentElem: HTMLDivElement;
    };
    public siteToEdit: SiteModel = new SiteModel();

    public siteId: string | null = null;

    public siteLocationsSrv: SiteLocationService = new SiteLocationService();

    public locationPath: Array<{id: string; title: string; type: string}> = [];

    // public formsSiteResults: boolean | false = false;
    public showSearchResults: boolean | false = false;

    public created() {
        this.siteId = this.$route.params['siteId'];
        // this.formsSiteResults = false;
        this.showSearchResults = false;
    }

    public mounted() {
        this.getSiteToEdit(this.siteId!);
        this.siteLocationsSrv.getSiteLocations(this.siteId!);
        this.siteLocationsSrv.selectedLcoation = null;
    }

    public startX: number | null = null;
    public startY: number | null = null;
    public startWidth: number | null = null;
    public startHeight: number | null = null;

    public onListMouseDown(e: any) {
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.startWidth = parseInt(document.defaultView?.getComputedStyle(this.$refs.searchSectionElem)?.width ?? '0', 10);
        this.startHeight = parseInt(document.defaultView?.getComputedStyle(this.$refs.searchSectionElem)?.height ?? '0', 10);

        document.documentElement.addEventListener('mousemove', this.doDrag, false);
        document.documentElement.addEventListener('mouseup', this.stopDrag, false);
    }

    doDrag(e: any) {
        this.$refs.searchSectionElem.style.width = `${this.startWidth + e.clientX - (this.startX ?? 0)}px`;
        this.$refs.searchSectionElem.style.height = `${this.startHeight + e.clientY - (this.startY ?? 0)}`;
    }

    stopDrag(e: any) {
        document.documentElement.removeEventListener('mousemove', this.doDrag, false);
        document.documentElement.removeEventListener('mouseup', this.stopDrag, false);
    }

    public startX1: number | null = null;
    public startY1: number | null = null;
    public startWidth1: number | null = null;
    public startHeight1: number | null = null;

    public parentHeight: number | null = null;
    public currentHeight: number | null = null;

    public onBrowserMouseDown(e: any) {
        this.startX1 = e.clientX;
        this.startY1 = e.clientY;
        // this.startWidth1 = parseInt(document.defaultView?.getComputedStyle(this.$refs.jobListElem)?.width ?? '0', 10);
        this.startHeight1 = parseInt(document.defaultView?.getComputedStyle(this.$refs.areaBrowserElem)?.height ?? '0', 10);

        this.parentHeight = parseInt(document.defaultView?.getComputedStyle(this.$refs.areaBrowserElem)?.height ?? '0', 10);

        document.documentElement.addEventListener('mousemove', this.doDrag1, false);
        document.documentElement.addEventListener('mouseup', this.stopDrag1, false);
    }

    doDrag1(e: any) {
        // this.$refs.searchSectionElem.style.width = `${this.startWidth1 + e.clientX - (this.startX1 ?? 0)}px`;
        this.currentHeight = this.startHeight1 + e.clientY - (this.startY1 ?? 0);
        this.$refs.areaBrowserElem.style.height = `${this.currentHeight}px`;
    }

    stopDrag1(e: any) {
        document.documentElement.removeEventListener('mousemove', this.doDrag1, false);
        document.documentElement.removeEventListener('mouseup', this.stopDrag1, false);
    }

    public goToLocation(locationId: string) {
        const found = this.siteLocationsSrv.siteLocations.find(x => x.id === locationId);
        found && this.locationItemClick(found);
    }

    public formsSiteResultsEvent(state: boolean) {
        // this.formsSiteResults = state;
    }

    public showSearchResultsEvent(state: boolean) {
        this.showSearchResults = state;
    }

    public onSiteClick() {
        this.locationPath = [];
        this.showSearchResults = false;
        this.siteLocationsSrv.selectedLcoation = null;
    }

    public locationItemClick(location: LocationModel, fromSearch?: boolean) {
        this.locationPath = [];
        let locationId = location.id;
        let foundLocation: LocationModel | undefined = location;

        let locationId1 = location.id;
        let foundLocation1: LocationModel | undefined | null = null;

        this.showSearchResults = false;

        while (locationId1 != null) {
            if (locationId1) {
                foundLocation1 = this.siteLocationsSrv.siteLocations.find(x => x.id === locationId1);
            }
            if (foundLocation1) {
                foundLocation1.expanded = true;
            }
            locationId1 = foundLocation1?.locationId;
        }

        while (locationId != null) {
            if (foundLocation) {
                this.locationPath.push({id: foundLocation.id!, title: foundLocation.title!, type: 'location'});
            }
            locationId = foundLocation?.locationId;
            if (locationId) {
                foundLocation = this.siteLocationsSrv.siteLocations.find(x => x.id === locationId);
            }
        }
        if (this.siteLocationsSrv.site) {
            this.locationPath.push({id: this.siteLocationsSrv.site.id!, title: this.siteLocationsSrv.site.siteName!, type: 'site'});
        }
        this.locationPath = this.locationPath.reverse();

        if (location.type === LOCATION_TYPES.EQUIPMENT) {
            this.siteLocationsSrv.getSiteLocation(location.id!);
            this.siteLocationsSrv.loadLocationDetailRules(location.id!);
        } else if (location.type === LOCATION_TYPES.DISTRIBUTION) {
            this.siteLocationsSrv.getSiteLocation(location.id!);
        } else if (location.type === LOCATION_TYPES.JUNCTION_BOX) {
            this.siteLocationsSrv.getSiteLocation(location.id!);
            this.siteLocationsSrv.loadLocationDetailRules(location.id!);
        } else {
            this.LoaderSrv.showFullScreenLoader();

            this.siteLocationsSrv.loadLocationDetailRules(location.id!);

            new LocationApi()
                .getLocationById(location.id!, {
                    include: [
                        {
                            relation: 'locationDetail',
                        },
                        {
                            relation: 'documentations',
                        },
                        {
                            relation: 'switchBoards',
                        },
                        {
                            relation: 'wiringCables',
                            order: ['sequence'],
                        },
                    ],
                })
                .subscribe(
                    res => {
                        if (res.Data) {
                            this.siteLocationsSrv.selectedLcoation = new LocationModel(res.Data);

                            // if (
                            //     this.siteLocationsSrv.selectedLcoation &&
                            //     (!this.siteLocationsSrv.selectedLcoation?.approvalType ||
                            //         typeof this.siteLocationsSrv.selectedLcoation?.approvalType === 'string')
                            // ) {
                            //     this.siteLocationsSrv.selectedLcoation.approvalType = [];
                            // }

                            // if (
                            //     this.siteLocationsSrv.selectedLcoation &&
                            //     (!this.siteLocationsSrv.selectedLcoation?.environmentalCondition ||
                            //         typeof this.siteLocationsSrv.selectedLcoation?.environmentalCondition === 'string')
                            // ) {
                            //     this.siteLocationsSrv.selectedLcoation.environmentalCondition = [];
                            // }
                        } else {
                            // this.siteLocationsSrv.selectedLcoation = new LocationModel({locationId: location.id});
                            this.siteLocationsSrv.selectedLcoation = null;
                        }
                    },
                    err => {
                        this.AlertSrv.show('warning', '$t.Common.SiteSetup.LoadError');
                    }
                )
                .add(() => {
                    this.LoaderSrv.hideFullScreenLoader();
                });
        }
    }

    public getSiteToEdit(id: string) {
        this.LoaderSrv.showFullScreenLoader();
        new SitesApi()
            .getSiteById(id)
            .subscribe(
                res => {
                    this.siteToEdit = res.Data ?? new SiteModel();
                    this.siteLocationsSrv.site = this.siteToEdit;
                },
                err => {
                    this.AlertSrv.show('error', 'Common.SiteSetup.LoadSiteError');
                }
            )
            .add(() => {
                this.LoaderSrv.hideFullScreenLoader();
            });
    }

    public saveEquipmentDetail() {
        if (this.siteLocationsSrv.selectedLcoation?.equipmentDetail) {
            if (!this.siteLocationsSrv.selectedLcoation.equipmentDetail.id) {
                this.siteLocationsSrv.selectedLcoation.equipmentDetail.locationId = this.siteLocationsSrv.selectedLcoation.id!;

                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .CreateLocationEquipmentDetail(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.equipmentDetail)
                    .subscribe(
                        res => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            if (res.Data) {
                                this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveEquipmentSuccess');
                                this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);

                                this.checkEquipmentRules(this.siteLocationsSrv.selectedLcoation!.id!);
                            }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveEquipmentError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            } else {
                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .UpdateLocationEquipmentDetail(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.equipmentDetail)
                    .subscribe(
                        res => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            // if (res.Data) {
                            this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveEquipmentSuccess');

                            this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);

                            this.checkEquipmentRules(this.siteLocationsSrv.selectedLcoation!.id!);
                            // }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveEquipmentError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            }
        }
    }

    public saveDistributionPanel() {
        if (this.siteLocationsSrv.selectedLcoation?.distributionPanel) {
            if (!this.siteLocationsSrv.selectedLcoation.distributionPanel.id) {
                this.siteLocationsSrv.selectedLcoation.distributionPanel.locationId = this.siteLocationsSrv.selectedLcoation.id!;

                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .CreateLocationDistributionPanel(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.distributionPanel)
                    .subscribe(
                        res => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            if (res.Data) {
                                this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveDpSuccess');
                                this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);
                            }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveDpError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            } else {
                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .UpdateLocationDistributionPanel(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.distributionPanel)
                    .subscribe(
                        res => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            // if (res.Data) {
                            this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveDpSuccess');

                            this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);
                            // }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveDpError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            }
        }
    }

    public saveJunctionBoxDetail() {
        if (this.siteLocationsSrv.selectedLcoation?.junctionBoxDetail) {
            if (!this.siteLocationsSrv.selectedLcoation.junctionBoxDetail.id) {
                this.siteLocationsSrv.selectedLcoation.junctionBoxDetail.locationId = this.siteLocationsSrv.selectedLcoation.id!;

                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .CreateLocationJunctionBoxDetail(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.junctionBoxDetail)
                    .subscribe(
                        res => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            if (res.Data) {
                                this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveJunctionBoxSuccess');
                                this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);

                                this.checkJunctionBoxRules(this.siteLocationsSrv.selectedLcoation!.id!);
                            }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveJunctionBoxError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            } else {
                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .UpdateLocationJunctionBoxDetail(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.junctionBoxDetail)
                    .subscribe(
                        res => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            // if (res.Data) {
                            this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveJunctionBoxSuccess');

                            this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);

                            this.checkJunctionBoxRules(this.siteLocationsSrv.selectedLcoation!.id!);
                            // }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveJunctionBoxError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            }
        }
    }

    // public saveSwitchBoards() {
    //     if (this.siteLocationsSrv.selectedLcoation?.switchBoards) {
    //         const switchBoardsArray = this.siteLocationsSrv.selectedLcoation?.switchBoards;
    //         if (switchBoardsArray && switchBoardsArray.length) {
    //             console.log('this.siteLocationsSrv.selectedLcoation?.switchBoards', this.siteLocationsSrv.selectedLcoation?.switchBoards);
    //             for (let i = 0; i < switchBoardsArray.length; i++) {
    //                 const board = switchBoardsArray[i];
    //                 if (board.id) {
    //                     board.locationId = this.siteLocationsSrv.selectedLcoation.id!;

    //                     this.LoaderSrv.showFullScreenLoader();
    //                     new LocationApi()
    //                         .CreateLocationSwitchBoard(this.siteLocationsSrv.selectedLcoation.id!, board)
    //                         .subscribe(
    //                             res => {
    //                                 console.log(this.siteLocationsSrv.selectedLcoation?.id);
    //                                 if (res.Data) {
    //                                     this.AlertSrv.show('success', 'Distribution Panel has been saved successfully!');
    //                                     this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);
    //                                 }
    //                             },
    //                             err => {
    //                                 console.log(this.siteLocationsSrv.selectedLcoation?.id);
    //                                 this.AlertSrv.show('error', 'Unable to save distribution panel. Please try again later!');
    //                             }
    //                         )
    //                         .add(() => {
    //                             this.LoaderSrv.hideFullScreenLoader();
    //                         });
    //                 }
    //             }
    //         }

    //         if (!this.siteLocationsSrv.selectedLcoation.switchBoards.id) {
    //             this.siteLocationsSrv.selectedLcoation.switchBoards.locationId = this.siteLocationsSrv.selectedLcoation.id!;

    //             this.LoaderSrv.showFullScreenLoader();
    //             new LocationApi()
    //                 .CreateLocationDistributionPanel(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.distributionPanel)
    //                 .subscribe(
    //                     res => {
    //                         console.log(this.siteLocationsSrv.selectedLcoation?.id);
    //                         if (res.Data) {
    //                             this.AlertSrv.show('success', 'Distribution Panel has been saved successfully!');
    //                             this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);
    //                         }
    //                     },
    //                     err => {
    //                         console.log(this.siteLocationsSrv.selectedLcoation?.id);
    //                         this.AlertSrv.show('error', 'Unable to save distribution panel. Please try again later!');
    //                     }
    //                 )
    //                 .add(() => {
    //                     this.LoaderSrv.hideFullScreenLoader();
    //                 });
    //         } else {
    //             this.LoaderSrv.showFullScreenLoader();
    //             new LocationApi()
    //                 .UpdateLocationDistributionPanel(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.distributionPanel)
    //                 .subscribe(
    //                     res => {
    //                         console.log(this.siteLocationsSrv.selectedLcoation?.id);
    //                         // if (res.Data) {
    //                         this.AlertSrv.show('success', 'Distribution Panel has been saved successfully!');

    //                         this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);
    //                         // }
    //                     },
    //                     err => {
    //                         console.log(this.siteLocationsSrv.selectedLcoation?.id);
    //                         this.AlertSrv.show('error', 'Unable to save distribution panel. Please try again later!');
    //                     }
    //                 )
    //                 .add(() => {
    //                     this.LoaderSrv.hideFullScreenLoader();
    //                 });
    //         }
    //     }
    // }

    public checkRules(locationId: string) {
        this.LoaderSrv.showFullScreenLoader('$t.Common.SiteSetup.CheckLocationRules');
        new LocationApi()
            .CheckLocationDetailRules(locationId)
            .subscribe(
                res => {
                    this.AlertSrv.show('success', '$t.Common.SiteSetup.CheckLocationRulesSuccess');
                    this.siteLocationsSrv.loadLocationDetailRules(locationId);
                },
                err => {
                    this.AlertSrv.show('error', '$t.Common.SiteSetup.CheckLocationRulesError');
                }
            )
            .add(() => {
                this.LoaderSrv.hideFullScreenLoader();
            });
    }

    public checkEquipmentRules(locationId: string) {
        this.LoaderSrv.showFullScreenLoader('$t.Common.SiteSetup.CheckEquipmentRules');
        new LocationApi()
            .CheckEquipmentDetailRules(locationId)
            .subscribe(
                res => {
                    this.AlertSrv.show('success', '$t.Common.SiteSetup.CheckEquipmentRulesSuccess');
                    this.siteLocationsSrv.loadLocationDetailRules(locationId);
                },
                err => {
                    this.AlertSrv.show('error', '$t.Common.SiteSetup.CheckEquipmentRulesError');
                }
            )
            .add(() => {
                this.LoaderSrv.hideFullScreenLoader();
            });
    }

    public checkJunctionBoxRules(locationId: string) {
        this.LoaderSrv.showFullScreenLoader('$t.Common.SiteSetup.CheckJunctionBoxRules');
        new LocationApi()
            .CheckJunctionBoxDetailRules(locationId)
            .subscribe(
                res => {
                    this.AlertSrv.show('success', '$t.Common.SiteSetup.CheckJunctionBoxRulesSuccess');
                    this.siteLocationsSrv.loadLocationDetailRules(locationId);
                },
                err => {
                    this.AlertSrv.show('error', '$t.Common.SiteSetup.CheckJunctionBoxRulesError');
                }
            )
            .add(() => {
                this.LoaderSrv.hideFullScreenLoader();
            });
    }

    public saveLocationDetail() {
        if (this.siteLocationsSrv.selectedLcoation?.locationDetail) {
            if (!this.siteLocationsSrv.selectedLcoation.locationDetail.id) {
                this.siteLocationsSrv.selectedLcoation.locationDetail.locationId = this.siteLocationsSrv.selectedLcoation.id!;

                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .CreateLocationLocationDetail(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.locationDetail)
                    .subscribe(
                        res => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            if (res.Data) {
                                this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveLocationDetailsSuccess');
                                this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);

                                this.checkRules(this.siteLocationsSrv.selectedLcoation!.id!);
                            }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.id);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveLocationDetailsError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            } else {
                this.LoaderSrv.showFullScreenLoader();
                new LocationApi()
                    .UpdateLocationLocationDetail(this.siteLocationsSrv.selectedLcoation.id!, this.siteLocationsSrv.selectedLcoation.locationDetail)
                    .subscribe(
                        res => {
                            // if (res.Data) {
                            console.log(this.siteLocationsSrv.selectedLcoation?.locationDetail?.dustLayerNotAppli);
                            this.AlertSrv.show('success', '$t.Common.SiteSetup.SaveLocationDetailsSuccess');

                            this.locationItemClick(this.siteLocationsSrv.selectedLcoation!);

                            this.checkRules(this.siteLocationsSrv.selectedLcoation!.id!);
                            // }
                        },
                        err => {
                            console.log(this.siteLocationsSrv.selectedLcoation?.locationDetail?.dustLayerNotAppli);
                            this.AlertSrv.show('error', '$t.Common.SiteSetup.SaveLocationDetailsError');
                        }
                    )
                    .add(() => {
                        this.LoaderSrv.hideFullScreenLoader();
                    });
            }
        }
    }
}
